<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH1')" />
            <Button label="입력" icon="pi pi-pencil" class="p-button-success mr-2" @click="btnAct('NEW1')" />
            <!-- <Button label="삭제" icon="pi pi-trash" class="p-button-danger  m-2" @click="btnAct('DELETE1')" :disabled="!selectedMinorCodes || !selectedMinorCodes.length" /> -->
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="compSeq" v-model="searchParams.compSeq" :options ="compCodes" optionLabel="codeNm" optionValue="code" required="true" :showClear="true" style="width: 11rem"/>
                        <label for="compSeq">센터명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="majorNm" type="text" v-model="searchParams.majorNm" @keydown.enter="btnAct('SEARCH1')"/>
                        <label for="majorNm">대분류명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="bizDiv" v-model="searchParams.bizDiv" :options ="bizDivCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                        <label for="bizDiv">업무구분</label>
                    </div>
                    <!-- <div class="p-field p-float-label m-2">
                        <Dropdown id="userType" v-model="searchParams.screenType" :options ="screenCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                        <label for="userType">화면구성</label>
                    </div> -->
                </div> 
            </template>

            <template #end>
                
            </template>
        </Toolbar>
        
        <Splitter style="height: 75vh" class="mb-5">
            <SplitterPanel  :size="35">
                <DataTable id="dt1" ref="dt1" :value="majorCodes" dataKey="majorSeq" :scrollable="false" scrollHeight="79vh" showGridlines 
                    selectionMode="single" v-model:selection="selectedMajorCode" 
                    editMode="row" v-model:editingRows="editingRows1" 
                    @rowEditInit="onRowEditInit1"  @rowEditCancel="onRowEditCancel1" @rowEditSave="onRowEditSave1"
                    class="p-datatable-sm table-con"  responsiveLayout="scroll">
                    <Column field="majorSeq" header="코드" :sortable="true" style="min-width:5em; max-width:5em"></Column>
                    <Column field="majorNm" header="대분류명" :sortable="true" style="min-width:8em; max-width:8em">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="20" style="min-width:7em; max-width:7em"/>
                        </template>
                    </Column>
                    <Column field="majorId" header="ID" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="20" style="min-width:6em; max-width:6em"/>
                        </template>
                    </Column>
                    <Column field="bizDiv" header="업무구분" :sortable="true">
                        <template #body="{data}">
                            {{(bizDivCodes.find(e=>e.code == data.bizDiv)||{codeNm:""})['codeNm']}}
                        </template>
                        <template #editor="{ data, field }">
                            <Dropdown v-model="data[field]" :options="bizDivCodes" optionLabel="codeNm" optionValue="code" />
                        </template>
                    </Column>
                    <!-- <Column field="compSeq" header="센터코드" :sortable="true"></Column> -->
                    <Column :rowEditor="true" style="min-width:5rem" bodyStyle="text-align:center"></Column>
                    <Column :exportable="false" style="min-width:4em; max-width:4em">
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct('DELETE1',slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>
            </SplitterPanel>    

            <SplitterPanel  :size="65">
                <div class="card">
                    <div class="p-grid p-mt-1">
                        <div class="p-fluid p-col-2">
                            <span class ="p-float-label">
                                <InputText type="text" v-model.trim="selectedMajorCode.majorSeq" disabled />
                                <label>대분류코드</label>
                            </span>
                        </div>
                        <div class="p-fluid p-col-2">
                            <span class ="p-float-label">
                                <InputText type="text" v-model.trim="selectedMajorCode.majorNm" disabled />
                                <label>대분류명</label>
                            </span>
                        </div>
                        <div class="p-fluid p-col-2">
                            <span class ="p-float-label">
                                <InputText type="text" v-model.trim="selectedMajorCode.majorId" disabled />
                                <label>ID</label>
                            </span>
                        </div>
                        <div class="p-fluid p-col-6">
                            <span class ="p-float-label">
                                <InputText type="text" v-model.trim="selectedMajorCode.remark" disabled />
                                <label>비고</label>
                            </span>
                        </div>
                    </div>
                </div>
                <DataTable id="dt2" ref="dt2" :value="minorCodes" dataKey="minorSeq" 
                    selectionMode="multiple" v-model:selection="selectedMinorCodes" :scrollable="false" scrollHeight="79vh" showGridlines 
                    editMode="row" v-model:editingRows="editingRows2" 
                    @rowEditInit="onRowEditInit2"  @rowEditCancel="onRowEditCancel2" @rowEditSave="onRowEditSave2"
                    class="p-datatable-sm table-con"  responsiveLayout="scroll">
                    <template #header>
                        <div class="flex justify-content-between flex-wrap">
                            <div class="flex align-items-center justify-content-center">
                                <i class="pi pi-tag mr-2"></i>
                                <span>소분류</span>
                            </div>
                            <div class="flex align-items-center justify-content-center">
                                <Button label="추가" icon="pi pi-plus" class="p-button-secondary mr-2" @click="btnAct('NEW2')" />
                            </div>
                        </div>
                    </template>
                    <Column selectionMode="multiple" headerClass ="th-center" class="t-center" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                    <Column field="minorSeq" header="소분류코드" :sortable="true"></Column>
                    <Column field="minorNm" header="소분류명" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="20" style="min-width:8em; max-width:8em"/>
                        </template>
                    </Column>
                    <Column field="delimiter" header="구분문자" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="10" style="min-width:6em; max-width:6em"/>
                        </template>
                    </Column>
                    <Column field="sortOrd" header="정렬순서" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputNumber v-model="data[field]" :min="0" integeronly showButtons="true" inputStyle="width:3em"/>
                        </template>
                    </Column>
                    <Column field="useYn" header="사용여부" :sortable="true">
                        <template #body="slotProps">
                            <span>{{slotProps.data.useYn == 1 ? "Y":"N"}}</span>
                        </template>
                        <template #editor="{ data, field }">
                            <Dropdown v-model="data[field]" :options="yns" optionLabel="codeNm" optionValue="code" />
                        </template>
                    </Column>
                    <Column field="defaultVal" header="기본값" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputNumber v-model="data[field]" :min="0" integeronly showButtons="true" inputStyle="width: 4em"/>
                        </template>
                    </Column>
                    <Column field="remark" header="비고" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="100" style="width:5em;"/>
                        </template>
                    </Column>
                    <!-- <Column field="majorSeq" header="대분류코드" :sortable="true"></Column> -->
                    <!-- <Column field="compSeq" header="센터코드" :sortable="true"></Column> -->
                    <Column :rowEditor="true" style="min-width:5rem" bodyStyle="text-align:center"></Column>
                    <Column :exportable="false">
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct('DELETE2',slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>
            </SplitterPanel>
        </Splitter>
    </div>
</template>

<script>
import { ref, onMounted, reactive, watch } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import CodeService from '@/service/cm/CodeService';
import MajorCodeService from '@/service/cm/MajorCodeService';
import MinorCodeService from '@/service/cm/MinorCodeService';
import JsUtils from '@/utilities/JsUtils';


export default {
    setup() {
        onMounted(() => {
            searchParams.compSeq = 1;
			codeService.getEnvCodeList({ compSeq:1, upCode:'bizdiv'}).then(data=> bizDivCodes.value = data);  // 업무구분 코드

            btnAct('SEARCH1');
        })
        const codeService = new CodeService();
		const majorCodeService = new MajorCodeService();
        const minorCodeService = new MinorCodeService();
        const searchParams = reactive({compSeq:null,majorNm:null,bizDiv:null});
        const toast = useToast();
        const confirm = useConfirm();
        const majorCodes = ref([]);
        const minorCodes = ref([]);
		const selectedMajorCode = ref({});
		const selectedMinorCodes = ref([]);
        const bizDivCodes = ref([]);
        const editingRows1 = ref([]);
        const editingRows2 = ref([]);
        const originalRows1 = ref({});
        const originalRows2 = ref({});
        const compCodes = ref([
            {codeNm: '경남도청', code: 1},
        ]);
        const screenCodes = ref([
            {codeNm: '소분류', code: 1},
            {codeNm: '타이틀', code: 2}
        ]);
        const yns = ref([
            {codeNm: '사용', code: 1},
            {codeNm: '중지', code: 0}
        ]);
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH1":
                        searchMajorCodes();
                        break;
                case "SEARCH2":
                        searchMinorCodes();
                        break;          
                case "NEW1":
                        addNewItem1();
                        break;
                case "NEW2":
                        addNewItem2();                  
                        break;
                default:
                        break;
            }
        }

        const rowBtnAct = (_act, code)=>
        {
            switch(_act)
            {
                case "DELETE1":
                    confirmDeleteOne1(code);
                    break;
                case "DELETE2":
                    confirmDeleteOne2(code);
                    break;
                default:
                    break;
            }
        }

        /**
         * 대분류 목록을 조회한다
         */
        const searchMajorCodes = () => {
            editingRows1.value = [];

            majorCodeService.getList(searchParams).then(data => majorCodes.value = data);
			return;
        };

        /**
         * 대분류 목록에 신규 행을 추가한다
         */
        const addNewItem1 = () => {
            // 이미 편집중인 row가 있으면 취소한다 - 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows1.value.length > 0) {
                return;
            }

            var newCode = {compSeq: searchParams.compSeq};
            if(majorCodes.value.length > 0) {
                // 기존 목록 뒤에 추가한다
                majorCodes.value.splice(0,0, newCode);
            }
            else {
                // 목록의 첫번째에 추가한다
                majorCodes.value.push(newCode);
                //majorCodes.value.unshift(newCode);
            }

            // 목록의 첫번째 row를 편집 상태로 변경한다
            editingRows1.value = [...editingRows1.value, majorCodes.value[0]];    
        }

        /**
         * 대분류 행 편집 시작 시
         */
        const onRowEditInit1 = (event) =>{
            // 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows1.value.length > 1) {
                // 목록에서 마지막으로 선택한 행이 배열에서 마지막에 추가되므로 마지막으로 추가된 항목을 삭제한다
                editingRows1.value.pop();
                return;
            }

            originalRows1.value[event.index] = {...majorCodes.value[event.index]};
        }

        /**
         * 대분류 행 편집 취소 시
         */
        const onRowEditCancel1 = (event) => {
            let {newData} = event;
            if(newData == null || newData.majorSeq == null) {  // 화면에서 신규 추가한 경우
                majorCodes.value.shift(); // 배열의 맨 앞의 항목을 제거한다.
                editingRows1.value = [];
                return;
            }

            majorCodes.value[event.index] = originalRows1.value[event.index];
        }  

        /**
         * 대분류 행 저장 시
         */
        const onRowEditSave1 = (event) =>{
            let {newData, index} = event;

            if(!JsUtils.checkUndefineColumns(newData,["compSeq","majorNm","majorId"])){
                // 현재 수정중인 row를 편집 상태로 변경한다
                editingRows1.value = [...editingRows1.value, newData];    
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'법인코드, 대분류명, 대분류ID는 필수입력 항목입니다', life:2000});
                return;
            }

            if(newData.majorSeq == null) {
                majorCodeService.insertOne(newData).then(() => {                    
                    toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});
                    btnAct('SEARCH1');
                });
            } else {
                majorCodeService.updateOne(newData).then(() => {
                    majorCodes.value[index] = newData;
                    toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                });
            }
        }

        /**
         * 대분류 행 삭제 시
         */
        const confirmDeleteOne1 = (code) =>{
            confirm.require({
                message:`대분류(${code.majorNm})를 삭제하시겠습니까?`,
                header: '대분류 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteOne1(code);
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteOne1 = (code) => {
            majorCodeService.deleteOne(code.compSeq, code.majorSeq)
                .then(() => {                    
                    toast.add({severity:'success', summary: '성공', detail: '삭제 되었습니다', life: 3000});
                    // 대분류 목록을 재조회 한다
                    btnAct('SEARCH1');
                    // 소분류 목록을 지운다
                    minorCodes.value = [];
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };

        /**
         * 대분류에 속한 소분류 목록 조회 시
         */
        const searchMinorCodes = () => {
            selectedMinorCodes.value = [];
            editingRows2.value = [];
            
            minorCodeService.getList({compSeq: selectedMajorCode.value.compSeq, majorSeq:selectedMajorCode.value.majorSeq}).then(data=> {
                minorCodes.value = data;
                /*
                codeHelpConds.value.forEach(row => {
                    row.emptyYn = row.emptyYn == 1 ? true : false;
                    row.disableYn = row.disableYn == 1 ? true : false;
                    row.useYn = row.useYn == 1 ? true : false;
                });
                */
            });
        }

        /**
         * 소분류 목록에 신규 행을 추가한다
         */
        const addNewItem2 = () => {
            if(selectedMajorCode.value == null || selectedMajorCode.value.majorSeq == null) {
                toast.add({serverity:'warn', summary: '확인', detail: '대분류 목록에서 코드를 선택하세요', life: 3000});
                return;
            }

            // 이미 편집중인 row가 있으면 취소한다 - 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows2.value.length > 0) {
                return;
            }

            var newCode = {compSeq: selectedMajorCode.value.compSeq, majorSeq: selectedMajorCode.value.majorSeq, useYn: true};
            if(minorCodes.value.length > 0) {
                // 기존 목록 뒤에 추가한다
                var _ = require('lodash');
                const lastCode = _.maxBy(minorCodes.value, 'sortOrd'); // 마지막 순번
                if(lastCode === undefined) {
                    newCode.sortOrd = minorCodes.value.length + 1;
                }
                else {
                    newCode.sortOrd = lastCode.sortOrd + 1;
                }
                minorCodes.value.splice(0,0, newCode);
            }
            else {
                // 목록의 첫번째에 추가한다
                minorCodes.value.push(newCode);
                //minorCodes.value.unshift(newCode);
            }

            // 목록의 첫번째 row를 편집 상태로 변경한다
            editingRows2.value = [...editingRows2.value, minorCodes.value[0]];    
        }

        /**
         * 소분류 행 편집 시작 시
         */
        const onRowEditInit2 = (event) =>{
            // 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows2.value.length > 1) {
                // 목록에서 마지막으로 선택한 행이 배열에서 마지막에 추가되므로 마지막으로 추가된 항목을 삭제한다
                editingRows2.value.pop();
                return;
            }

            originalRows2.value[event.index] = {...minorCodes.value[event.index]};
        }

        /**
         * 소분류 행 편집 취소 시
         */
        const onRowEditCancel2 = (event) => {
            let {newData} = event;
            if(newData == null || newData.minorSeq == null) {  // 화면에서 신규 추가한 경우
                minorCodes.value.shift(); // 배열의 맨 앞의 항목을 제거한다.
                editingRows2.value = [];
                return;
            }

            minorCodes.value[event.index] = originalRows2.value[event.index];
        }

        /**
         * 소분류 행 저장 시
         */
        const onRowEditSave2 = (event) =>{
            let {newData, index} = event;

            if(!JsUtils.checkUndefineColumns(newData,["compSeq","majorSeq","minorNm"])){
                // 현재 수정중인 row를 편집 상태로 변경한다
                editingRows2.value = [...editingRows2.value, newData];    
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'법인코드, 대분류코드는 필수입력 항목입니다', life:1000});
                return;
            }

            if(newData.minorSeq == null) {
                minorCodeService.insertOne(newData).then(() => {                    
                    toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});
                    btnAct('SEARCH2');
                });
            } else {
                minorCodeService.updateOne(newData).then(() => {
                    minorCodes.value[index] = newData;
                    toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                });
            }
        }

        /**
         * 소분류 행 삭제 시
         */
        const confirmDeleteOne2 = (code) =>{
            confirm.require({
                message:`소분류(${code.minorNm})를 삭제하시겠습니까?`,
                header: '소분류 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteOne2(code);
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteOne2 = (code) => {
            minorCodeService.deleteOne(code.compSeq, code.majorSeq, code.minorSeq)
                .then(() => {                    
                    toast.add({severity:'success', summary: '삭제 성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH2');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };

        /*
        const confirmDeleteList2 = () =>{
            confirm.require({
                message:'선택된 건(들)을 삭제하시겠습니까?',
                header: '소분류 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteList2();                    
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteList2 = () => {
            minorCodeService.deleteList(selectedMinorCodes.value)
                .then(() => {                    
                    selectedMinorCodes.value = [];
                    toast.add({severity:'success', summary: '삭제 성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH2');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };
        */
        
        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, majorCodes.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(majorCodes.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        // 대분류 행 선택 시, 해당 대분류 코드의 소분류 목록을 조회하여 표시한다
        watch(()=>selectedMajorCode.value,
        (meta)=>{
            minorCodes.value = [];
            editingRows2.value = [];
            if(meta.majorSeq)
            {
                minorCodeService.getList({compSeq: selectedMajorCode.value.compSeq, majorSeq:meta.majorSeq}).then(data=> minorCodes.value = data);
                //minorCodeService.getList(selectedMajorCode.value).then(data=>minorCodes.value = data);
            }
        })

        return { 
            dt, majorCodes, minorCodes, selectedMajorCode, selectedMinorCodes, searchParams, bizDivCodes, screenCodes, compCodes, yns, 
            searchMajorCodes, editingRows1, originalRows1, addNewItem1, onRowEditInit1, onRowEditCancel1, onRowEditSave1, confirmDeleteOne1, deleteOne1,
            searchMinorCodes, editingRows2, originalRows2, addNewItem2, onRowEditInit2, onRowEditCancel2, onRowEditSave2, confirmDeleteOne2, deleteOne2, 
            btnAct, rowBtnAct, downloadExcel, exportCSV, 
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.code-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .code-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
